import { trpc } from '@src/data/trpc';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Step, usePurchaseStore } from './-purchaseStore';
import { View } from './-01_View';
import { Confirmed } from './-02_Confirmed';
import { LoadingMessage } from '@src/components/LoadingMessage';
import { ErrorMessage } from '@src/components/ErrorMessage';
import { Route as index_route } from '@routes/index';
import { Sheet } from 'react-modal-sheet';
import { useShallow } from 'zustand/react/shallow';
import { useEffect } from 'react';
import { Confetti } from '@src/components/Confetti';

export const Route = createFileRoute('/$service/$productSKU/')({
  staticData: {
    title: 'Product SKU',
  },
  loaderDeps: (deps) => ({
    address: deps.search.address,
  }),
  loader: async ({ params, deps }) => {
    const response = await trpc.getProductSKU.query({
      network: import.meta.env.VITE_NETWORK,
      productSkuId: Number(params.productSKU),
      address: deps.address,
    });
    if (response === null || !response)
      throw new Error(
        `No product found for "${params.service}"/${params.productSKU}`
      );
    return response;
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        name: 'description',
        content: loaderData
          ? `Purchase ${loaderData.title} for ${loaderData.price} $PART`
          : 'Onchain retail therapy',
      },
      {
        title: loaderData ? `${loaderData.title}` : 'Puzzle Arcade Store',
      },
    ],
  }),
  staleTime: 15_000,
  pendingComponent: function Component() {
    const { service } = Route.useParams();
    return <LoadingMessage message={`Loading product for ${service}`} />;
  },
  errorComponent: function Component({ error }) {
    return <ErrorMessage error={error} />;
  },
  component: function RouteComponent() {
    const [step, _close] = usePurchaseStore(
      useShallow((state) => [state.step, state.close])
    );
    const navigate = useNavigate({ from: Route.fullPath });

    return (
      <>
        <View />
        <Sheet
          className='mx-auto max-w-[750px]'
          isOpen={step === Step._02_Confirmed}
          onClose={() => _close()}
          detent='content-height'
          disableDrag={true}
          style={{ zIndex: 10 }}
        >
          <Sheet.Container
            style={{
              borderTopLeftRadius: '20px',
              borderTopRightRadius: '20px',
            }}
            className='p-4 pb-8'
          >
            <Confirmed />
          </Sheet.Container>
          <Sheet.Backdrop
            onTap={() =>
              navigate({
                to: index_route.to,
              }).then(() => _close())
            }
          />
        </Sheet>
      </>
    );
  },
});
